export default __webpack_public_path__ + "src/images/packages/villa-mangata/ca9ddd944a5040ca06ac7828eedc1cdc-2.jpg";